import React from 'react';
import { withTranslation } from 'react-i18next';

class CardsTableHeader extends React.Component {
  render() {
    const { showActions, t } = this.props;
    return (
      <thead>
        <tr>
          <th>{t('library.cards.name')}</th>
          <th>{t('library.cards.description')}</th>
          <th>{t('library.cards.ageRanges')}</th>
          <th>{t('library.cards.skills')}</th>
          <th>{t('library.cards.domains')}</th>
          {showActions && <th>{t('library.cards.actions')}</th>}
          <th></th>
        </tr>
      </thead>
    );
  }
}

export default withTranslation()(CardsTableHeader);
